import { useContext } from 'react';
import LocaleContext from 'contexts/Locale/LocaleContext';

export default function useLocale() {
    const { state } = useContext(LocaleContext);
    return [state.locale];
}
